import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { PayrollRun, PayrollRunCycleType } from "@wingspanhq/wingspan-api-sdk";

import { PAYROLL_CURRENCY } from "../../constants";
import { selectorPayrollRunNumber } from "../../selectors/selectorPayrollRunNumber";
import { selectorPayrollRunStatusColor } from "../../selectors/selectorPayrollRunStatusColor";
import { selectorPayrollRunStatusDetail } from "../../selectors/selectorPayrollRunStatusDetail";
import { selectorPayrollRunStatusPill } from "../../selectors/selectorPayrollRunStatusPill";
import { formatPayPeriodRange, parsePayrollAmount } from "../../utils";
import { BreakdownCountCell } from "../BreakdownCountCell";

/**
 * The employee payroll history table, to the new payroll design: a run is
 * identified by its number and pay period, and the status carries a secondary
 * line ("Next payroll: …", "Paid …").
 *
 * Separate from the contractor table on the Payables tab, which keeps the
 * retired v1 shape — the two surfaces are not variants of one table.
 */
export const getColumnsEmployee = (): WSTableColumn<PayrollRun>[] => [
  {
    config: { header: { text: "Payrolls" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell
        secondaryText={
          rowItem.data.cycleType === PayrollRunCycleType.OFF_CYCLE
            ? "Off-Cycle"
            : undefined
        }
        text={selectorPayrollRunNumber(rowItem.data)}
      />
    )
  },
  {
    config: { header: { text: "Pay period" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatPayPeriodRange(
          rowItem.data.payPeriodStartDate,
          rowItem.data.payPeriodEndDate
        )}
      />
    )
  },
  {
    config: { header: { text: "Status" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell
        pill={selectorPayrollRunStatusPill(rowItem.data.status)}
        secondaryText={selectorPayrollRunStatusDetail(rowItem.data)}
        secondaryTextColor={selectorPayrollRunStatusColor(rowItem.data.status)}
      />
    )
  },
  {
    config: {
      header: { text: "Total # of pay statements" },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: rowItem => (
      <BreakdownCountCell payrollRunId={rowItem.data.id ?? ""} />
    )
  },
  {
    config: { header: { text: "Amount" }, justify: "end" },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatMoney(
          parsePayrollAmount(rowItem.data.totalAmount),
          PAYROLL_CURRENCY
        )}
      />
    )
  }
];
